import { Box, Typography } from "@mui/material";
import React, { FC } from "react";

import Loading from "../Loading/Loading";

interface ILoadingOverlayProps {
  title?: string;
  subTitle?: string;
  noTransparent?: boolean;
}

const LoadingOverlay: FC<ILoadingOverlayProps> = ({ title, subTitle, noTransparent }) => {
  return (
    <Box sx={{
      position: "absolute", width: "100%", minHeight: "100%", borderRadius: "0.75rem", overflow: "hidden",
      background: noTransparent ? "#F9F6F4" :"#faf6f4CC", zIndex: 1, top: 0, left: 0,
    }}>
      <Box sx={{
        position: "sticky",
        top: "45%",
        padding: "0 1rem",
        textAlign: "center",
      }}>
        <Loading />
        <Typography variant="h3" sx={{ mb: 1, mt: 2 }}>
          {title}
        </Typography>
        <Typography variant="body1">
          {subTitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingOverlay;
